"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MainContainer = exports.InputCustom = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _variables = require("../../../global-files/variables");

var _templateObject, _templateObject2;

var MainContainer = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  align-items: center;\n  width: fit-content;\n  height: 20px;\n  padding: 0 5px;\n  box-sizing: border-box;\n  background: #fafafa;\n  border-radius: 2px;\n  border: ", ";\n"])), function (props) {
  return props.error && "1px solid red";
});

exports.MainContainer = MainContainer;

var InputCustom = _styledComponents.default.input(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  border-width: 0;\n  width: 100%;\n  font-family: ", ";\n  font-weight: 400;\n  font-size: 11px;\n  line-height: 19px;\n  border-width: 0;\n  color: ", ";\n  background-color: ", ";\n  outline: none;\n  &::placeholder {\n    font-size: 12px;\n    color: #d4d1d7;\n  }\n"])), _variables.FontFamily.AvenirNext, _variables.GlobalColors.s5, _variables.GlobalColors.s2);

exports.InputCustom = InputCustom;